module.exports = __webpack_public_path__ + "img/026-come.f1a9c95c.svg";